import { Box, Divider } from "@mui/material";
import React from "react";

import C2ProDemoScript from "./c2pro";
import ImaqFollowUpScript from "./imaq/followup";
import ImaqInitialSetupScript from "./imaq/setup";
import ImaqTleSyncScript from "./imaq/tlesync";
import LeBourgetDemoFollowUpScript from "./lebourget/followup";
import LeBourgetDemoSetupScript from "./lebourget/setup";
import MpsDemoScript from "./mps";
import SafranDemoFollowUpScript from "./safran/followup";
import SafranDemoSetupScript from "./safran/setup";

const DemoScripts: React.FC = ({}) => {
  return (
    <>
      <Box sx={{ flexGrow: 1, padding: 2 }}>
        <MpsDemoScript />
        <ImaqTleSyncScript />
        <ImaqInitialSetupScript />
        <ImaqFollowUpScript />
        <LeBourgetDemoSetupScript />
        <LeBourgetDemoFollowUpScript />
        <SafranDemoSetupScript />
        <SafranDemoFollowUpScript />
        <C2ProDemoScript />
      </Box>
      <Divider sx={{ my: 1 }} />
    </>
  );
};

export default DemoScripts;
